// extracted by mini-css-extract-plugin
module.exports = {"farm-title-box":"farm-title-box___1cG9y"};